module.exports = __webpack_public_path__ + "img/eye_saver.366105a2.svg";